import React from 'react';
import MarginGuardHeld from './MarginGuardHeld';

// FIRST-RELEASE LEGACY UI PRESERVED, INACTIVE LINE COMMENTS ONLY
// Original source: 34b99b9f6e8d7980f6ee89d06ad8ba9515129386:frontend/src/components/MarginGuardHero.js
// Original UTF-8 SHA256: 6ad482fe91c2ffdfbe3b071d3af71cbffd3654a231e3ee12c9b313ad62fde889
// Held legacy UI cannot fetch, render historical scores, or execute a fallback.
// Restore only after verified tenant/staff access, current data, denial tests,
// independent review and explicit owner approval of restoration.
// BEGIN ORIGINAL SOURCE
// /**
//  * Margin Guard Hero Component for Dashboard
//  * 
//  * This is the primary hero section showing:
//  * - This Week's Fix List (Top 3)
//  * - 5 Score Tiles (Margin Guard, Promise, Expectation, PCR, Backorder)
//  * 
//  * This component is shown when Shopify is connected.
//  * When Shopify is not connected, a CTA to connect is shown instead.
//  */
// 
// import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { 
//   Shield, 
//   TrendingUp, 
//   TrendingDown, 
//   AlertTriangle, 
//   ChevronRight,
//   Clock,
//   XCircle,
//   Package,
//   RefreshCw,
//   ExternalLink,
//   Zap,
//   CheckCircle,
//   ArrowRight,
//   ShoppingBag,
//   Slack
// } from 'lucide-react';
// import { toast } from 'sonner';
// import { LINKS } from '../config/siteLinks';
// 
// const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
// 
// // Score Tile Component
// const ScoreTile = ({ label, score, delta, icon: Icon, color = 'emerald' }) => {
//   const colorClasses = {
//     emerald: 'from-emerald-500/20 to-emerald-500/5 border-emerald-500/30 text-emerald-400',
//     blue: 'from-blue-500/20 to-blue-500/5 border-blue-500/30 text-blue-400',
//     violet: 'from-violet-500/20 to-violet-500/5 border-violet-500/30 text-violet-400',
//     amber: 'from-amber-500/20 to-amber-500/5 border-amber-500/30 text-amber-400',
//     rose: 'from-rose-500/20 to-rose-500/5 border-rose-500/30 text-rose-400'
//   };
// 
//   const getScoreColor = (score) => {
//     if (score >= 80) return 'text-emerald-400';
//     if (score >= 60) return 'text-amber-400';
//     return 'text-rose-400';
//   };
// 
//   return (
//     <div className={`rounded-xl border bg-gradient-to-br p-4 ${colorClasses[color]}`}>
//       <div className="flex items-center justify-between mb-2">
//         <Icon className={`w-5 h-5 ${colorClasses[color].split(' ').pop()}`} />
//         {delta !== undefined && delta !== null && (
//           <span className={`text-xs font-medium flex items-center gap-0.5 ${delta >= 0 ? 'text-emerald-400' : 'text-rose-400'}`}>
//             {delta >= 0 ? <TrendingUp className="w-3 h-3" /> : <TrendingDown className="w-3 h-3" />}
//             {delta >= 0 ? '+' : ''}{delta.toFixed(0)}
//           </span>
//         )}
//       </div>
//       <div className={`text-3xl font-bold ${getScoreColor(score)}`}>
//         {Math.round(score || 0)}
//       </div>
//       <div className="text-xs text-slate-400 mt-1">{label}</div>
//     </div>
//   );
// };
// 
// // Fix Item Component
// const FixItem = ({ fix, index, onViewTrace }) => {
//   const severityColors = {
//     high: 'border-rose-500/50 bg-rose-500/10',
//     medium: 'border-amber-500/50 bg-amber-500/10',
//     low: 'border-slate-600/50 bg-slate-800/30'
//   };
// 
//   const severityText = {
//     high: 'text-rose-400',
//     medium: 'text-amber-400',
//     low: 'text-slate-400'
//   };
// 
//   return (
//     <div className={`rounded-xl border p-4 ${severityColors[fix.severity] || severityColors.low}`}>
//       <div className="flex items-start justify-between gap-4">
//         <div className="flex-1">
//           <div className="flex items-center gap-2 mb-1">
//             <span className={`w-6 h-6 rounded-full flex items-center justify-center text-xs font-bold ${
//               fix.severity === 'high' ? 'bg-rose-500/20 text-rose-400' :
//               fix.severity === 'medium' ? 'bg-amber-500/20 text-amber-400' :
//               'bg-slate-600/50 text-slate-400'
//             }`}>
//               {index + 1}
//             </span>
//             <span className={`text-xs font-semibold uppercase ${severityText[fix.severity] || severityText.low}`}>
//               {fix.severity}
//             </span>
//           </div>
//           <h4 className="text-base font-semibold text-white mb-1">{fix.title}</h4>
//           {fix.impact && (
//             <p className="text-sm text-slate-400">
//               {fix.impact.orders_at_risk || fix.impact.ordersAtRisk} orders at risk
//               {fix.impact.est_weekly_usd_high && ` • ~$${fix.impact.est_weekly_usd_high.toLocaleString()}`}
//             </p>
//           )}
//         </div>
//         <button
//           onClick={() => onViewTrace?.(fix.trace_id)}
//           className="shrink-0 px-3 py-1.5 rounded-lg bg-white/5 hover:bg-white/10 text-sm text-slate-300 flex items-center gap-1 transition-colors"
//         >
//           View
//           <ChevronRight className="w-4 h-4" />
//         </button>
//       </div>
//     </div>
//   );
// };
// 
// // Connect Shopify Hero Component — directs to Shopify App Store
// const ConnectShopifyHero = ({ onConnect }) => {
//   return (
//     <div className="rounded-2xl border border-emerald-500/30 bg-gradient-to-br from-emerald-500/10 via-slate-900/50 to-slate-900/80 p-8 mb-8">
//       <div className="flex items-start justify-between gap-8">
//         <div className="flex-1">
//           <div className="flex items-center gap-3 mb-4">
//             <div className="p-3 rounded-xl bg-emerald-500/20">
//               <Shield className="w-8 h-8 text-emerald-400" />
//             </div>
//             <div>
//               <h2 className="text-2xl font-bold text-white">Margin Guard</h2>
//               <p className="text-emerald-400 text-sm font-medium">Your weekly decision surface</p>
//             </div>
//           </div>
// 
//           <p className="text-lg text-slate-300 mb-6 max-w-2xl">
//             Connect Shopify to generate your first <strong className="text-white">Margin Guard Brief</strong> —
//             see what's breaking, why, and exactly what it costs you weekly.
//           </p>
// 
//           <div className="flex flex-wrap gap-4 mb-6">
//             <div className="flex items-center gap-2 text-sm text-slate-400">
//               <CheckCircle className="w-4 h-4 text-emerald-400" />
//               Weekly fix list (top 3)
//             </div>
//             <div className="flex items-center gap-2 text-sm text-slate-400">
//               <CheckCircle className="w-4 h-4 text-emerald-400" />
//               5 health scores (0-100)
//             </div>
//             <div className="flex items-center gap-2 text-sm text-slate-400">
//               <CheckCircle className="w-4 h-4 text-emerald-400" />
//               $ impact per issue
//             </div>
//           </div>
// 
//           <a
//             href={LINKS.shopifyInstallUrl}
//             target="_blank"
//             rel="noopener noreferrer"
//             className="px-6 py-3 rounded-xl bg-emerald-600 hover:bg-emerald-700 text-white font-semibold inline-flex items-center gap-2 transition-colors"
//           >
//             <ShoppingBag className="w-5 h-5" />
//             Install from Shopify App Store
//             <ExternalLink className="w-4 h-4" />
//           </a>
//         </div>
// 
//         <div className="hidden lg:block">
//           <div className="w-64 p-4 rounded-xl border border-slate-700 bg-slate-800/50">
//             <div className="text-xs text-slate-500 mb-2">Sample Brief Preview</div>
//             <div className="space-y-2">
//               <div className="flex items-center justify-between">
//                 <span className="text-xs text-slate-400">Margin Guard</span>
//                 <span className="text-sm font-bold text-emerald-400">82</span>
//               </div>
//               <div className="flex items-center justify-between">
//                 <span className="text-xs text-slate-400">Promise</span>
//                 <span className="text-sm font-bold text-blue-400">90</span>
//               </div>
//               <div className="flex items-center justify-between">
//                 <span className="text-xs text-slate-400">PCR</span>
//                 <span className="text-sm font-bold text-amber-400">71</span>
//               </div>
//             </div>
//             <div className="mt-3 pt-3 border-t border-slate-700">
//               <div className="flex items-center gap-2">
//                 <AlertTriangle className="w-3 h-3 text-amber-400" />
//                 <span className="text-xs text-slate-300">2 fixes needed</span>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };
// 
// // Main Hero Component
// const MarginGuardHero = ({ isShopifyConnected = false, isSlackConnected = false, onConnectShopify }) => {
//   const navigate = useNavigate();
//   const [loading, setLoading] = useState(true);
//   const [data, setData] = useState(null);
//   const [error, setError] = useState(null);
//   const [slackStatus, setSlackStatus] = useState(isSlackConnected);
// 
//   useEffect(() => {
//     if (isShopifyConnected) {
//       fetchMarginGuardData();
//       fetchSlackStatus();
//     } else {
//       setLoading(false);
//     }
//   }, [isShopifyConnected]);
// 
//   const fetchMarginGuardData = async () => {
//     try {
//       setLoading(true);
//       const res = await fetch(`${BACKEND_URL}/api/margin-guard/summary?period=7d`);
//       if (res.ok) {
//         const summary = await res.json();
//         setData(summary);
//       } else {
//         setError('Failed to load data');
//       }
//     } catch (err) {
//       console.error('Error fetching Margin Guard data:', err);
//       setError('Unable to connect');
//     } finally {
//       setLoading(false);
//     }
//   };
// 
//   const fetchSlackStatus = async () => {
//     try {
//       const token = sessionStorage.getItem('session_token');
//       const res = await fetch(`${BACKEND_URL}/api/integration/status`, {
//         credentials: 'include',
//         headers: token ? { 'Authorization': `Bearer ${token}` } : {}
//       });
//       if (res.ok) {
//         const status = await res.json();
//         setSlackStatus(status?.slack?.connected || false);
//       }
//     } catch (err) {
//       console.error('Error fetching Slack status:', err);
//     }
//   };
// 
//   const handleViewTrace = (traceId) => {
//     navigate(`/dashboard/margin-guard/trace/${traceId}`);
//   };
// 
//   // If Shopify not connected, show connect CTA
//   if (!isShopifyConnected) {
//     return <ConnectShopifyHero onConnect={onConnectShopify} />;
//   }
// 
//   // Loading state
//   if (loading) {
//     return (
//       <div className="rounded-2xl border border-slate-800 bg-slate-900/50 p-8 mb-8">
//         <div className="flex items-center gap-3 mb-6">
//           <div className="p-3 rounded-xl bg-emerald-500/20">
//             <Shield className="w-8 h-8 text-emerald-400" />
//           </div>
//           <div>
//             <h2 className="text-2xl font-bold text-white">Margin Guard</h2>
//             <p className="text-slate-400 text-sm">Loading your weekly brief...</p>
//           </div>
//         </div>
//         <div className="flex items-center justify-center py-12">
//           <RefreshCw className="w-8 h-8 text-slate-500 animate-spin" />
//         </div>
//       </div>
//     );
//   }
// 
//   // Error state
//   if (error) {
//     return (
//       <div className="rounded-2xl border border-slate-800 bg-slate-900/50 p-8 mb-8">
//         <div className="flex items-center gap-3 mb-4">
//           <div className="p-3 rounded-xl bg-emerald-500/20">
//             <Shield className="w-8 h-8 text-emerald-400" />
//           </div>
//           <div>
//             <h2 className="text-2xl font-bold text-white">Margin Guard</h2>
//             <p className="text-rose-400 text-sm">{error}</p>
//           </div>
//         </div>
//         <button
//           onClick={fetchMarginGuardData}
//           className="px-4 py-2 rounded-lg bg-slate-800 hover:bg-slate-700 text-white text-sm"
//         >
//           Retry
//         </button>
//       </div>
//     );
//   }
// 
//   const fixList = data?.fix_list || [];
//   const topFixes = fixList.slice(0, 3);
// 
//   return (
//     <div className="mb-8">
//       {/* Header */}
//       <div className="flex items-center justify-between mb-6">
//         <div className="flex items-center gap-3">
//           <div className="p-3 rounded-xl bg-emerald-500/20">
//             <Shield className="w-8 h-8 text-emerald-400" />
//           </div>
//           <div>
//             <h2 className="text-2xl font-bold text-white">Margin Guard</h2>
//             <p className="text-slate-400 text-sm">This week's fix list • 7-day health scores</p>
//           </div>
//         </div>
//         <button
//           onClick={() => navigate('/dashboard/margin-guard')}
//           className="px-4 py-2 rounded-xl bg-emerald-600 hover:bg-emerald-700 text-white font-medium flex items-center gap-2 transition-colors"
//         >
//           Open Full Dashboard
//           <ExternalLink className="w-4 h-4" />
//         </button>
//       </div>
// 
//       {/* Score Tiles Row */}
//       <div className="grid grid-cols-2 md:grid-cols-5 gap-3 mb-6">
//         <ScoreTile
//           label="Margin Guard"
//           score={data?.scores?.margin_guard}
//           delta={data?.delta_7d?.margin_guard}
//           icon={Shield}
//           color="emerald"
//         />
//         <ScoreTile
//           label="Promise"
//           score={data?.scores?.promise_business}
//           delta={data?.delta_7d?.promise_business}
//           icon={Clock}
//           color="blue"
//         />
//         <ScoreTile
//           label="Expectation"
//           score={data?.scores?.expectation_calendar}
//           delta={data?.delta_7d?.expectation_calendar}
//           icon={TrendingUp}
//           color="violet"
//         />
//         <ScoreTile
//           label="PCR"
//           score={data?.scores?.pcr}
//           delta={data?.delta_7d?.pcr}
//           icon={XCircle}
//           color="amber"
//         />
//         <ScoreTile
//           label="Backorder"
//           score={data?.scores?.backorder}
//           delta={data?.delta_7d?.backorder}
//           icon={Package}
//           color="rose"
//         />
//       </div>
// 
//       {/* Fix List */}
//       <div className="rounded-2xl border border-slate-800 bg-slate-900/50 p-6">
//         <div className="flex items-center justify-between mb-4">
//           <h3 className="text-lg font-semibold text-white flex items-center gap-2">
//             <Zap className="w-5 h-5 text-amber-400" />
//             This Week's Fix List
//           </h3>
//           {fixList.length > 3 && (
//             <button
//               onClick={() => navigate('/dashboard/margin-guard')}
//               className="text-sm text-emerald-400 hover:text-emerald-300 flex items-center gap-1"
//             >
//               View all {fixList.length} fixes
//               <ChevronRight className="w-4 h-4" />
//             </button>
//           )}
//         </div>
// 
//         {topFixes.length > 0 ? (
//           <div className="space-y-3">
//             {topFixes.map((fix, index) => (
//               <FixItem
//                 key={fix.fix_id || index}
//                 fix={fix}
//                 index={index}
//                 onViewTrace={handleViewTrace}
//               />
//             ))}
//           </div>
//         ) : (
//           <div className="text-center py-8 rounded-xl border border-emerald-500/30 bg-emerald-500/5">
//             <CheckCircle className="w-10 h-10 text-emerald-400 mx-auto mb-3" />
//             <p className="text-lg font-medium text-white mb-1">All systems healthy</p>
//             <p className="text-sm text-slate-400">No critical fixes needed this week</p>
//           </div>
//         )}
//       </div>
// 
//       {/* Slack CTA - Show when Shopify connected but Slack not */}
//       {!slackStatus && (
//         <div className="mt-6 rounded-2xl border border-[#7C3AED]/40 bg-gradient-to-r from-[#7C3AED]/10 to-slate-900/50 p-6">
//           <div className="flex items-start gap-4">
//             <div className="p-3 rounded-xl bg-[#7C3AED]/20">
//               <Slack className="w-7 h-7 text-[#7C3AED]" />
//             </div>
//             <div className="flex-1">
//               <h3 className="text-lg font-semibold text-white mb-1">
//                 Get your weekly brief in Slack
//               </h3>
//               <p className="text-sm text-slate-400 mb-4">
//                 Receive Margin Guard scores, fix alerts, and approve decisions without leaving Slack. 
//                 Most teams connect Slack to stay aligned.
//               </p>
//               <div className="flex items-center gap-3">
//                 <button
//                   onClick={() => navigate('/dashboard/settings/slack')}
//                   className="px-4 py-2 rounded-xl bg-[#7C3AED] hover:bg-[#7C3AED]/90 text-white font-medium flex items-center gap-2 transition-colors"
//                   data-testid="margin-guard-connect-slack"
//                 >
//                   <Slack className="w-4 h-4" />
//                   Connect Slack
//                 </button>
//                 <span className="text-xs text-slate-500">Takes 30 seconds</span>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };
// 
// export default MarginGuardHero;
// END ORIGINAL SOURCE

export default function HeldMarginGuardHero() { return <MarginGuardHeld/>; }
